<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <v-card-title>
          <v-row>
            <v-col cols="12" md="12">
              <h3>New Training</h3>
            </v-col>
          </v-row>
        </v-card-title>

        <v-row class="mt-3">
          <v-col cols="12" md="6">
            <v-autocomplete ref="company_id" v-model="dataAdd.company_id" :items="company_list"
              label="Select Company Name" item-text="name" item-value="id" outlined dense
              v-on:change="showdepartName(), showAuthorize(), showAdmin()"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="6">
            <v-autocomplete ref="department_id" v-model="dataAdd.department_id" :items="department_list"
              label="Select Department Name" item-text="department_name" item-value="id" outlined dense
              v-on:change="showPositionName"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="6">
            <v-autocomplete ref="position_id" v-model="dataAdd.position_id" :items="position_list"
              label="Select Positions Name" item-text="name" item-value="id" outlined dense></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="6">
            <v-autocomplete ref="authorize_id" v-model="dataAdd.authorize_id" :items="authorize_list"
              label="Select Authorize Name" item-text="sgm_name" item-value="id" outlined dense></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="6">
            <v-text-field ref="tranning_name" v-model="dataAdd.tranning_name" outlined dense
              label="Training Name"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col cols="12" md="6">
            <v-autocomplete ref="admin_id" v-model="dataAdd.admin_id" :items="admin_list"
              label="Select Administrator Name" item-text="name" item-value="id" outlined dense></v-autocomplete>
          </v-col>
        </v-row>

        <!-- date  -->
        <v-row class="mt-0">
          <v-col cols="12" sm="4" md="4">
            <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date"
              transition="scale-transition" offset-y min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on" outlined dense label="Select Date"></v-text-field>
              </template>
              <v-date-picker v-model="date_training" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu_date = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu_date.save(date_training)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="heightsize55" cols="12" sm="3" md="3">
            <v-menu v-model="start_hours" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="start_time" label="Start" append-icon="mdi-clock-outline" readonly v-on="on"
                  outlined dense></v-text-field>
              </template>
              <v-time-picker v-if="start_hours" v-model="start_time"
                @change="closeMenuStart(), checktime()"></v-time-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-menu v-model="end_hours" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="end_time" label="End" append-icon="mdi-clock-outline" readonly v-on="on" outlined
                  dense></v-text-field>
              </template>
              <v-time-picker v-if="end_hours" v-model="end_time" @change="closeMenuEnd(), checktime()"></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <br />
        <div>
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed width="100" class="mr-5 buttonblue" @click="saveItem()">
                Save
              </v-btn>
              <v-btn depressed outlined width="100" @click="$router.back()">
                Cancel
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
export default {
  name: "NewAdvance",
  data() {
    return {
      company_list: [],
      department_list: [],
      authorize_list: [],
      admin_list: [],
      position_list: [],
      tranning_name: "",
      dataAdd: {
        company_id: 0,
        department_id: 0,
        position_id: 0,
        authorize_id: 0,
        tranning_name: "",
        admin_id: 0,
        status: "INACTIVE",
        jobtitle_id: 0,
        date_start: "",
        date_end: "",
      },
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      menu_date: false,
      date_training: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      start_hours: false,
      start_time: "",
      end_hours: false,
      end_time: "",
      date: "",
      time: ""
    };
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.date_training);
    },
  },
  watch: {},
  async mounted() {
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    await this.loadCompany();
    this.$hideLoader();
  },
  methods: {
    async loadCompany() {
      const res_com = await api.getAllCompany();
      this.company_list = res_com.data;
      //console.log("this.company_list")
      //console.log(this.company_list)
    },
    async showdepartName() {
      await this.$showLoader()
      const res_dep = await api.getNewAllDepartment_By_CompanyID(this.dataAdd.company_id);
      this.department_list = res_dep.data;
      await this.$hideLoader()
    },
    async showAuthorize() {
      await this.$showLoader()
      const res_aut = await api.getSettingGroupMenu_By_CompanyID(this.dataAdd.company_id);
      this.authorize_list = res_aut.data;
      await this.$hideLoader()
    },
    async showAdmin() {
      await this.$showLoader()
      const res_adm = await api.getAccountsByCompany(this.dataAdd.company_id);
      //console.log("res_adm.data")
      //console.log(res_adm.data)
      this.admin_list = res_adm.data;
      await this.$hideLoader()
    },
    async showPositionName() {
      await this.$showLoader()
      const res_po = await api.getAllPositionTranning(this.dataAdd.company_id, this.dataAdd.department_id);
      this.position_list = res_po.data;
      await this.$hideLoader()
    },
    closeMenuStart() {
      this.start_hours = false; // ปิดเมนู
    },
    closeMenuEnd() {
      this.end_hours = false; // ปิดเมนู
    },
    async checktime() {
      //console.log(this.start_time)
      //console.log(this.end_time)
      if (this.start_time != "" && this.end_time != "") {
        if (this.start_time >= this.end_time) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Invalid Information",
            "Time(Start<END), Please New choose a DateTime",
            "text-h5 red--text text-center"
          );
          return;
        }
      }

    },
    async saveItem() {
      //console.log(this.dataAdd)
      if (this.dataAdd.company_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a Company",
          "text-h5 red--text text-center"
        );
        this.$refs["company_id"].focus();
        return;
      }
      if (this.dataAdd.department_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a department",
          "text-h5 red--text text-center"
        );
        this.$refs["department_id"].focus();
        return;
      }
      if (this.dataAdd.position_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a Position",
          "text-h5 red--text text-center"
        );
        this.$refs["position_id"].focus();
        return;
      }
      if (this.dataAdd.authorize_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a Authorize",
          "text-h5 red--text text-center"
        );
        this.$refs["authorize_id"].focus();
        return;
      }
      if (this.dataAdd.tranning_name == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please enter the Training Course Name",
          "text-h5 red--text text-center"
        );
        this.$refs["tranning_name"].focus();
        return;
      }

      if (this.dataAdd.admin_id == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a Administrator",
          "text-h5 red--text text-center"
        );
        this.$refs["admin_id"].focus();
        return;
      }
      if (this.start_time == "" || this.end_time == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Please choose a DateTime",
          "text-h5 red--text text-center"
        );
        return;
      }
      if (this.start_time != "" && this.end_time != "") {
        if (this.start_time >= this.end_time) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Invalid Information",
            "Time(Start<END), Please New choose a DateTime",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      //console.log(this.dataAdd)
      const res_check = await api.getTRANNING_HByTranningName(this.dataAdd.tranning_name)
      //console.log("res_check.data")
      //console.log(res_check.data)
      if (res_check.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Invalid Information",
          "Training Name Duplicate, Please Enter Document Type Data",
          "text-h5 red--text text-center"
        );
        this.$refs["tranning_name"].focus();
        return;
      }
      this.$showLoader();
      let data_add_job = {
        name: this.dataAdd.tranning_name,
        company_id: this.dataAdd.company_id,
        department_id: this.dataAdd.department_id,
        create_by: localStorage.getItem(server.USER_ID),
        status: "INACTIVE",
      }

      const res_addjob = await api.addJobtitle(data_add_job)

      this.dataAdd.jobtitle_id = res_addjob.data.id;

      let d_start = "";
      let e_start = "";
      d_start = `${this.date_training} ${this.start_time}:00`
      e_start = `${this.date_training} ${this.end_time}:00`

      this.dataAdd.date_start = d_start;
      this.dataAdd.date_end = e_start;

      const res_add = await api.addTRANNING_H(this.dataAdd);
      if (res_add.status == 200 || res_add.status == 201) {

        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Information Saved",
          "Information successfully saved",
          "text-h5 green--text text-center",
          `/training-list`
        );
      } else {
        this.$hideLoader()
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  async beforeCreate() {
    //console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
.center {
  text-align: center;
}

.minheighttime {
  min-height: 40px;
  cursor: pointer;
  font-size: initial;
  padding-top: 7px;
  padding-left: 7px;
}

.border-dt-picker {
  border: 1px solid;
  /* border-radius: 5px; */
  height: 30px;
}
</style>